import { getSessionToken, logout } from "./auth";
export var SESSION_EXPIRED = "SESSION_EXPIRED";
export var LOGGED_IN = "LOGGED_IN";
export var LOGGED_OUT = "LOGGED_OUT";

var sessionExpired = function sessionExpired() {
  return {
    type: SESSION_EXPIRED
  };
};

var loggedIn = function loggedIn() {
  return {
    type: LOGGED_IN
  };
};

var loggedOut = function loggedOut() {
  return {
    type: LOGGED_OUT
  };
};

var initialState = {
  sessionToken: getSessionToken()
};
export var actions = {
  loggedOut: loggedOut,
  loggedIn: loggedIn,
  sessionExpired: sessionExpired
};
export default (function () {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case LOGGED_IN:
        return Object.assign({}, state, {
          sessionToken: getSessionToken()
        });

      case LOGGED_OUT:
        return Object.assign({}, state, {
          sessionToken: getSessionToken()
        });

      case SESSION_EXPIRED:
        logout();
        return Object.assign({}, state, {
          sessionToken: getSessionToken()
        });

      default:
        return Object.assign({}, initialState, state);
    }
  };
});